webpackJsonp([216929306842663],{

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Image = __webpack_require__(5);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _BackgroundImage = __webpack_require__(19);
	
	var _BackgroundImage2 = _interopRequireDefault(_BackgroundImage);
	
	__webpack_require__(115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'section',
	    { className: 'cta relative' },
	    _react2.default.createElement(_BackgroundImage2.default, {
	      src: '/images/uploads/background-image-3.jpg',
	      alt: 'background-image 3'
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'relative' },
	      _react2.default.createElement(
	        'div',
	        { className: 'inner-text' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          props.title
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'big-body' },
	          props.subtitle
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'button-container' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: 'Button', to: '/contact' },
	            'Contact Us'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: 'Button Button--inverted', to: '/contact' },
	            'Online Examination'
	          )
	        )
	      ),
	      _react2.default.createElement('div', { className: 'clear' })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 160:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _custom = __webpack_require__(92);
	
	var _custom2 = _interopRequireDefault(_custom);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Image = __webpack_require__(5);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _BackgroundImage = __webpack_require__(19);
	
	var _BackgroundImage2 = _interopRequireDefault(_BackgroundImage);
	
	__webpack_require__(160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import 'react-id-swiper/src/styles/css/swiper.css'
	exports.default = function (_ref) {
	  var _ref$homeGallery = _ref.homeGallery,
	      homeGallery = _ref$homeGallery === undefined ? [] : _ref$homeGallery,
	      _ref$alt = _ref.alt,
	      alt = _ref$alt === undefined ? '' : _ref$alt;
	
	  var params = {
	    slidesPerView: 1,
	    spaceBetween: 30,
	    loop: true,
	    centeredSlides: true,
	    pagination: {
	      el: '.swiper-pagination',
	      clickable: true
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'Gallery-Home' },
	    _react2.default.createElement(
	      _custom2.default,
	      params,
	      homeGallery.map(function (fields, index) {
	        return _react2.default.createElement(
	          'div',
	          { key: 'GalleryImage' + index },
	          _react2.default.createElement(
	            'div',
	            { className: 'Gallery-Card relative' },
	            _react2.default.createElement(_BackgroundImage2.default, {
	              src: '/images/uploads/background-image-5.svg',
	              alt: 'header image'
	            }),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: fields.link },
	              _react2.default.createElement(
	                'div',
	                { className: 'Gallery-Img' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'Gallery-Img--Container relative' },
	                  _react2.default.createElement(_BackgroundImage2.default, {
	                    src: fields.imageBefore,
	                    alt: fields.title,
	                    key: fields.imageBefore + index
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'Gallery-Img--Container relative' },
	                  _react2.default.createElement(_BackgroundImage2.default, {
	                    src: fields.imageAfter,
	                    alt: fields.title,
	                    key: fields.imageAfter + index
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'h4',
	              null,
	              fields.title
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              fields.subtitle
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Image = __webpack_require__(5);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	__webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Services = function (_Component) {
	  _inherits(Services, _Component);
	
	  function Services() {
	    _classCallCheck(this, Services);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Services.prototype.render = function render() {
	    var _props$singleService = this.props.singleService,
	        singleService = _props$singleService === undefined ? [] : _props$singleService;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'flex' },
	      singleService.map(function (list, index) {
	        return _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: list.link },
	          _react2.default.createElement(
	            'div',
	            { className: 'square', key: list.name },
	            _react2.default.createElement(_Image2.default, { className: 'icon', src: list.defaultIcon, alt: 'icon 1' }),
	            _react2.default.createElement(_Image2.default, {
	              className: 'icon-hover',
	              src: list.hoverIcon,
	              alt: 'icon 1 hover'
	            }),
	            _react2.default.createElement(
	              'p',
	              { className: 'service-title' },
	              list.name
	            )
	          )
	        );
	      })
	    );
	  };
	
	  return Services;
	}(_react.Component);
	
	exports.default = Services;
	module.exports = exports['default'];

/***/ }),

/***/ 74:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.HomePageTemplate = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PageHeader = __webpack_require__(23);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Content = __webpack_require__(26);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Image = __webpack_require__(5);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Services = __webpack_require__(124);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	var _Cta = __webpack_require__(79);
	
	var _Cta2 = _interopRequireDefault(_Cta);
	
	var _HomeGallery = __webpack_require__(139);
	
	var _HomeGallery2 = _interopRequireDefault(_HomeGallery);
	
	__webpack_require__(74);
	
	__webpack_require__(425);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Export Template for use in CMS preview
	var HomePageTemplate = exports.HomePageTemplate = function HomePageTemplate(_ref) {
	  var section1 = _ref.section1,
	      section2 = _ref.section2,
	      section3 = _ref.section3,
	      section4 = _ref.section4,
	      section5 = _ref.section5,
	      section6 = _ref.section6,
	      posts = _ref.posts,
	      _ref$gallery = _ref.gallery,
	      gallery = _ref$gallery === undefined ? [] : _ref$gallery;
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'main',
	      { className: 'Home' },
	      _react2.default.createElement(
	        'section',
	        { className: 'section--1 relative' },
	        _react2.default.createElement(_Image2.default, { background: true, src: section1.heroImage, alt: section1.title }),
	        _react2.default.createElement(
	          'div',
	          { className: 'relative container-banner' },
	          _react2.default.createElement(
	            'div',
	            { className: 'inner' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              section1.title
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'big-body' },
	              section1.subtitle
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { className: 'Button', to: '/Conact' },
	              'Contact Us'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'section--2  section thin' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            section2.content
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'section--3  section relative' },
	        _react2.default.createElement(_Image2.default, {
	          background: true,
	          src: section3.backgroundImage,
	          alt: 'background-image 2'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'relative services container' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            section3.title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex' },
	            _react2.default.createElement(_Services2.default, { singleService: section3.singleService })
	          )
	        )
	      ),
	      _react2.default.createElement(_Cta2.default, { title: section4.title, subtitle: section4.subtitle }),
	      _react2.default.createElement(
	        'section',
	        { className: 'section--5 section relative' },
	        _react2.default.createElement(_Image2.default, {
	          background: true,
	          src: section5.backgroundImage,
	          alt: 'background-image 4'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'relative container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columnContainer' },
	            _react2.default.createElement(
	              'div',
	              { className: 'left' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                section5.title
	              ),
	              _react2.default.createElement(_Content2.default, { src: section5.content }),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: 'Button Button--inverted', to: '/contact' },
	                'More About Us'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	// Export Default HomePage for front-end
	var HomePage = function HomePage(_ref2) {
	  var _ref2$data = _ref2.data,
	      page = _ref2$data.page,
	      posts = _ref2$data.posts;
	  return _react2.default.createElement(HomePageTemplate, _extends({}, page, page.frontmatter, {
	    body: page.html,
	    posts: posts.edges.map(function (post) {
	      return _extends({}, post.node, post.node.frontmatter, post.node.fields);
	    })
	  }));
	};
	
	exports.default = HomePage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 425:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-home-page-js-bf9c6bcce0aac1a500d4.js